export default {
    account: 'Cuenta',
    'export': 'Exportar',
    'export-from-latest-matching': 'Exportar desde la última coincidencia',
    'export-as-excel': 'Exportar a excel',
    'print-account-statement': 'Imprimir estado de cuenta',
    'brief': '(breve)',
    'view-match-table': 'Mostrar tabla de reconciliación',
    back: 'Deshacer',

    'account-num-or-name': 'Número o nombre de cuenta',
    'search-within-caption': 'Buscar por descripción',

    'from-date': 'De fecha',
    'to-date': 'Hasta fecha',
    'to': 'hasta',
    'show-all-columns': 'Mostrar todas las columans',
    
    refresh: 'Actualizar',
    'go-to-the-journal-of-entry': 'Ir al diario de asiento',
    match: 'Reconciliación',
    'account-match': 'Cancelar reconciliación de cuenta',
    'account-unmatch': 'Reconciliación de Cuenta',

    'are-you-sure-you-want-to-account-unmatch': '¿Estas seguro de cancelar la reconciliación de cuenta?',
    'are-you-sure-you-want-to-account-match': '¿Estas seguro de reconciliar de cuenta?',
    
    'currency-balances': 'Saldo de monedas:',
    'more-details': 'Mas detalles',
    
    'sum-debit': 'Débito total',
    'sum-credits': 'Crédito total',
    'currency-debits': 'Débito en moneda extranjera',
    'currency-credits': 'Crédito en moneda extranjera',
    'currency-equivalent': 'Saldo en otra moneda',
    
    'select-the-currency-to-display-the-equivalent-value': 'Seleccionar la moneda a cambiar',

    today: 'Hoy',
    balance: 'Saldo:',

    'sum-result-headers': {
        'sum-debits': 'Débito total',
        'sum-credits': 'Crédito total',
        balance: 'Saldo',
        'equivalent-currency': 'Saldo en otra moneda',
        'currency-equivalent': 'Equivalente de moneda',
        'currencies-balance': 'Saldo de monedas',
    },

    'sum-currencies-result-headers': {
        'currency-debits': 'Débito en moneda extranjera',
        'currency-credits': 'Crédito en moneda extranjera',
    },

    headers: {
        balance: 'Saldo',
        debit: 'Deudor',
        credit: 'Acreedor',
        note: 'Descripción',
        'currency-debit': 'Débito en moneda extranjera',
        'currency-credit': 'Crédito en moneda extranjera',
        currency: 'Moneda',
        'currency-price': 'Precio',
        'currency-balances': 'Saldo de monedas',
        'paper-document-no': 'Ref. Doc.',
        date: 'Fecha',
    },
}